import addBustypeDialogTemplate from "./addBustypeDialog/addBustypeDialog.html";
import addBustypeDialogController from "./addBustypeDialog/addBustypeDialog.controller";
import isNil from "lodash/fp/isNil";
class Controller {
  constructor(
    Events,
    $state,
    $mdDialog,
    Bustype,
    $location,
    Messages,
    $stateParams,
    Sections
  ) {
    "ngInject";

    this.Events = Events;
    this.$state = $state;
    this.Bustype = Bustype;
    this.$location = $location;
    this.$mdDialog = $mdDialog;
    this.Messages = Messages;

    this.$stateParams = $stateParams;

    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.activeParams = this.$stateParams;
    this.sections = Sections.settingsSections;

    this.filterEvent = this.Events.getFilterEvent("bustypes");
    this.paginateEvent = this.Events.getPaginateEvent("bustypes");
    this.sortEvent = this.Events.getSortEvent("bustypes");
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
  }

  openDialog() {
    this.$mdDialog
      .show({
        controller: addBustypeDialogController,
        controllerAs: "$ctrl",
        template: addBustypeDialogTemplate,
        locals: {},
      })
      .then(
        ({
          description,
          city: { _id },
          seats,
          maxSeats,
          make,
          model,
          vehicleType,
          isAC,
          rideCategory,
        }) => {
          this.Bustype.post({
            description,
            city: _id,
            seats,
            max_seats: maxSeats,
            make,
            model,
            vehicle_type: vehicleType,
            ride_category: rideCategory,
            is_ac: isNil(isAC) ? false : isAC.value,
          })
            .$promise.then(({ _id: id }) => {
              this.Events.emit(
                this.successNotificationEvent,
                this.Messages.addMessage("Bustype")
              );
              this.$state.transitionTo("bustype", {
                id,
              });
            })
            .catch((err) => {
              this.Events.emit(this.errorNotificationEvent, err.data);
            });
        }
      );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/bustypes/bustypes.controller.js